import BASEAPIGESTTOR from '../api/gesttor'
import BASEURLPROJETOS from '../api/authProjetos'
import { payloadLoginGoogle } from '../../interfaces/google'

export function criarAcessoaAgenda () {
    return BASEAPIGESTTOR.post(`/google-agenda/auth`)
}

export function sincronizarAgenda () {
    return BASEAPIGESTTOR.post(`/google-agenda/sincronizacao`)
}

export function authGoogle () {
    return BASEURLPROJETOS.get('/google-auth')
}

export function authGoogleConfirmacao (payload: { code: string }) {
    return BASEURLPROJETOS.post(`/google-auth/projetos/confirmacao`, payload)
}

export function loginGoogle (payload: payloadLoginGoogle) {
    return BASEURLPROJETOS.post('/google-auth', payload)
}